// src/store/types/cityTypes.js
export const FETCH_CITIES_REQUEST = "FETCH_CITIES_REQUEST";
export const FETCH_CITIES_SUCCESS = "FETCH_CITIES_SUCCESS";
export const FETCH_CITIES_FAILURE = "FETCH_CITIES_FAILURE";

export const SET_SELECTED_CITY = "SET_SELECTED_CITY";

export const RESET_STORE = "RESET_STORE";

